import { ARInvoiceDetailSlidein } from '@/components/accounts-receivable/invoice-detail/ar-invoice-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function ARInvoiceDetailRoute() {
  const { arInvoiceId } = useParams({
    from: '/authenticated/accounts-receivable/invoices/$arInvoiceId',
  });
  const navigate = useNavigate();

  return (
    <ARInvoiceDetailSlidein
      invoiceId={arInvoiceId}
      isOpen
      onOpenChange={() => {
        navigate({ to: '..', search: true, viewTransition: true });
      }}
    />
  );
}
